import React from 'react';
import { AdComponent } from './AdComponent';

interface TreasureCardAdProps {
  /** Position in the grid (for analytics) */
  position?: number;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Ad component designed to replace every 4th treasure card
 * Matches the visual style of treasure cards
 */
export const TreasureCardAd: React.FC<TreasureCardAdProps> = ({
  position,
  className = ''
}) => {
  return (
    <div className={`treasure-card-ad ${className}`}>
      <AdComponent
        format="rectangle"
        responsive={true}
        className="treasure-card-ad-content"
        fallback={
          // Fallback content that matches treasure card styling
          <div className="bg-white rounded-2xl overflow-hidden shadow-card border border-gray-100">
            <div className="aspect-[4/3] bg-gradient-to-br from-teddy-100 to-teddy-200 flex items-center justify-center">
              <div className="text-center p-4">
                <div className="text-4xl mb-2">🎯</div>
                <div className="text-sm font-medium text-urban-600 mb-1">
                  Discover Local Businesses
                </div>
                <div className="text-xs text-urban-400">
                  Support your community
                </div>
              </div>
            </div>
            <div className="p-4">
              <div className="text-xs text-urban-400 mb-2 flex items-center gap-1">
                <svg className="w-3 h-3" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                </svg>
                <span>Your Area</span>
              </div>
              <div className="text-sm font-medium text-urban mb-2">
                Local Business Spotlight
              </div>
              <div className="flex justify-between items-center text-xs">
                <span className="text-urban-400">Sponsored</span>
                <div className="flex items-center gap-1 text-cardboard">
                  <span>✨</span>
                  <span>Featured</span>
                </div>
              </div>
            </div>
          </div>
        }
        showLoading={true}
        loadingComponent={
          // Loading state that matches treasure card styling
          <div className="bg-white rounded-2xl overflow-hidden shadow-card animate-pulse">
            <div className="aspect-[4/3] bg-gray-200"></div>
            <div className="p-4">
              <div className="h-3 bg-gray-200 rounded mb-2"></div>
              <div className="h-4 bg-gray-200 rounded mb-2"></div>
              <div className="flex justify-between">
                <div className="h-3 bg-gray-200 rounded w-16"></div>
                <div className="h-3 bg-gray-200 rounded w-12"></div>
              </div>
            </div>
          </div>
        }
        onError={(error) => {
          console.warn(`TreasureCardAd at position ${position} failed:`, error);
        }}
        onLoad={() => {
          console.log(`TreasureCardAd at position ${position} loaded successfully`);
        }}
        testMode={import.meta.env.DEV} // Show placeholder in development
        adType="treasure-card"
        position={position}
      />
    </div>
  );
};

export default TreasureCardAd;